/** Returns true when serialized payloads are equal (skips unnecessary state updates). */
export function isRefreshPayloadEqual<T>(previous: T | null, next: T | null): boolean {
  if (previous === next) {
    return true;
  }
  if (previous == null || next == null) {
    return false;
  }
  try {
    return JSON.stringify(previous) === JSON.stringify(next);
  } catch {
    return false;
  }
}

export function mergeLastUpdated(dates: Array<Date | null | undefined>): Date | null {
  const valid = dates.filter((value): value is Date => value instanceof Date);
  if (!valid.length) {
    return null;
  }
  return new Date(Math.max(...valid.map(date => date.getTime())));
}

export function buildRefreshWarningMessage(
  warnings: Array<string | null | undefined>,
  prefix = 'Some sections could not be refreshed. Existing data is shown.'
): string | null {
  const parts = warnings.filter(Boolean) as string[];
  if (!parts.length) {
    return null;
  }
  return `${prefix} ${parts.join(' · ')}`;
}
